import { useEffect, useState } from "react";

const navLinks = [
  { href: "#world", label: "Explore" },
  { href: "#categories", label: "Categories" },
  { href: "#products", label: "Products" },
  { href: "#market", label: "Market" },
  { href: "#visit", label: "Visit" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-foreground-950/85 backdrop-blur-md border-b border-foreground-800"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="group flex items-center gap-2 cursor-pointer">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-foreground-950">
            <i className="ri-flashlight-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-lg font-semibold tracking-tight transition-colors ${
              scrolled ? "text-background-50" : "text-background-50"
            }`}
          >
            FIST <span className="text-primary-400">LIMITED</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-label text-xs text-background-100/80 transition-colors hover:text-primary-400 cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="tel:07909324302"
            className="btn-light-outline h-10 px-4"
          >
            <i className="ri-phone-line"></i>
            07909 324302
          </a>
          <a href="#visit" className="btn-primary h-10 px-5">
            Enquire
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="flex items-center gap-2 md:hidden">
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-background-50"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-foreground-800 bg-foreground-950 md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col px-4 py-4">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-3 font-label text-xs text-background-100/80 transition-colors hover:text-primary-400"
              >
                {l.label}
              </a>
            ))}
            <a href="#visit" onClick={() => setOpen(false)} className="btn-primary mt-3 h-11 w-full">
              Enquire <i className="ri-arrow-right-line"></i>
            </a>
            <a href="tel:07909324302" className="btn-light-outline mt-3 h-11 w-full">
              <i className="ri-phone-line"></i> Call 07909 324302
            </a>
          </div>
        </div>
      )}
    </header>
  );
}